'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fat';
var iconName = 'newspaper';
var width = 512;
var height = 512;
var aliases = [128240];
var unicode = 'f1ea';
var svgPathData = 'M152 48c-22.1 0-40 17.9-40 40l0 336c0 15.7-6.4 29.8-16.8 40L440 464c30.9 0 56-25.1 56-56l0-320c0-22.1-17.9-40-40-40L152 48zM56 464c22.1 0 40-17.9 40-40L96 88c0-30.9 25.1-56 56-56l304 0c30.9 0 56 25.1 56 56l0 320c0 39.8-32.2 72-72 72L56 480c-30.9 0-56-25.1-56-56L0 136c0-4.4 3.6-8 8-8s8 3.6 8 8l0 288c0 22.1 17.9 40 40 40zM352 184c0-4.4 3.6-8 8-8l64 0c4.4 0 8 3.6 8 8s-3.6 8-8 8l-64 0c-4.4 0-8-3.6-8-8zm0 64c0-4.4 3.6-8 8-8l64 0c4.4 0 8 3.6 8 8s-3.6 8-8 8l-64 0c-4.4 0-8-3.6-8-8zM176 312c0-4.4 3.6-8 8-8l240 0c4.4 0 8 3.6 8 8s-3.6 8-8 8l-240 0c-4.4 0-8-3.6-8-8zm0 64c0-4.4 3.6-8 8-8l240 0c4.4 0 8 3.6 8 8s-3.6 8-8 8l-240 0c-4.4 0-8-3.6-8-8zm24-232c-4.4 0-8 3.6-8 8l0 80c0 4.4 3.6 8 8 8l80 0c4.4 0 8-3.6 8-8l0-80c0-4.4-3.6-8-8-8l-80 0zm-24 8c0-13.3 10.7-24 24-24l80 0c13.3 0 24 10.7 24 24l0 80c0 13.3-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24l0-80z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faNewspaper = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;